export default __webpack_public_path__ + "static/media/Connect.12bd0aeb.svg";